/** Shared module chrome: title, optional actions, loading/error status. */
export default function ModuleShell({
  title,
  description,
  actions,
  leading,
  loading,
  loadingLabel,
  error,
  errorLabel,
  children,
}) {
  return (
    <section className="module-shell">
      {leading}
      <header className={actions ? 'module-header module-header-row' : 'module-header'}>
        <div>
          <h1>{title}</h1>
          {typeof description === 'string' ? <p>{description}</p> : description}
        </div>
        {actions ? <div className="module-actions">{actions}</div> : null}
      </header>
      {loading && <p className="module-status">{loadingLabel}</p>}
      {error && (
        <p className="module-status module-status-error" role="alert">
          {errorLabel}
        </p>
      )}
      {children}
    </section>
  );
}
